import React, { CSSProperties, ReactNode } from 'react';
import { Col, Row, Statistic } from 'antd';

export type StatisticColumnItem = {
  title: ReactNode;
  value: string | number;
  span?: number;
  valueStyle?: CSSProperties;
};

export type StatisticColumnsProps = {
  items: StatisticColumnItem[];
  gutter?: number;
  className?: string;
  style?: CSSProperties;
};

const StatisticColumns: React.FC<StatisticColumnsProps> = ({
  items,
  gutter = 16,
  className,
  style,
}) => {
  if (!items.length) {
    return null;
  }

  const defaultSpan = Math.floor(24 / items.length) || 24;

  return (
    <Row gutter={gutter} className={className} style={style}>
      {items.map((item, index) => (
        <Col
          key={`${String(item.title)}-${index}`}
          span={item.span ?? defaultSpan}
        >
          <Statistic
            title={item.title}
            value={item.value}
            valueStyle={item.valueStyle}
          />
        </Col>
      ))}
    </Row>
  );
};

export default StatisticColumns;
